import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addRequestForm: {
		id: 'portal-settings-request-groups.portal-group.request-form.add-request-form',
		defaultMessage: 'Add request form',
		description: 'Button text for adding request form to a group',
	},
	selectRequestForm: {
		id: 'portal-settings-request-groups.portal-group.request-form.select-request-form',
		defaultMessage: 'Select a request form',
		description: 'Place holder text on the request forms dropdown under portal groups',
	},
});
